<script setup>
import { Handle, Position, useNode } from '@vue-flow/core';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useNodeAudience } from '../../composables/useNodeAudience.js';

const props = defineProps({
  data: { type: Object, default: () => ({}) },
  selected: { type: Boolean, default: false },
});

const { t } = useI18n();
const { id } = useNode();
const audienceCount = useNodeAudience(id);

const promptPreview = computed(() => {
  const p = props.data.prompt ?? '';
  return p.length > 40 ? p.slice(0, 40) + '…' : p;
});
</script>

<template>
  <div
    class="flow-node w-[180px] rounded-xl overflow-hidden shadow-md border-2 transition-all"
    :class="selected ? 'border-n-teal-8' : 'border-transparent'"
  >
    <Handle type="target" :position="Position.Top" />
    <div class="flex items-center gap-2 px-3 py-2 bg-n-teal-9 text-white">
      <span class="i-lucide-wand-2 size-4 shrink-0" />
      <span class="text-xs font-semibold truncate flex-1">{{ data.name || t('FLOW_BUILDER.NODES.GENERATE_MESSAGE.TITLE') }}</span>
      <span v-if="audienceCount !== null" class="text-[9px] bg-white/20 rounded-full px-1.5 py-0.5 font-medium tabular-nums shrink-0">
        {{ audienceCount }}
      </span>
    </div>
    <div class="px-3 py-2 bg-n-solid-1 text-n-slate-12 text-xs">
      <span v-if="promptPreview">{{ promptPreview }}</span>
      <span v-else class="text-n-slate-9">{{ t('FLOW_BUILDER.NODES.GENERATE_MESSAGE.CONFIGURE') }}</span>
    </div>
    <Handle type="source" :position="Position.Bottom" />
  </div>
</template>
